import React from 'react';

export const INVOLVED_OPTIONS = [
  // Updated to a richer, higher-contrast palette for better legibility
  { value: 1, label: 'Self', color: '#475569' },     // slate-600
  { value: 2, label: 'Individual Teammate', color: '#0EA5E9' }, // sky-500
  { value: 3, label: 'Several Teammates', color: '#F59E0B' },   // amber-500
  { value: 4, label: 'Another Team', color: '#F97316' }, // orange-500
  { value: 5, label: 'My Team', color: '#DB2777' },    // rose-600
  { value: 6, label: 'Multiple Teams', color: '#7C3AED' }, // violet-600
];

export const getInvolvedLabel = (value?: number) => {
  const opt = INVOLVED_OPTIONS.find((o) => o.value === value);
  return opt ? opt.label : 'None';
};

export const getInvolvedColor = (value?: number) => {
  const opt = INVOLVED_OPTIONS.find((o) => o.value === value);
  return opt ? opt.color : '#94A3B8';
};

export const renderInvolvedIcon = (value?: number, size = 16, colorOverride?: string) => {
  const color = colorOverride ?? getInvolvedColor(value);
  if (!color) return null;
  const commonProps = { width: size, height: size, viewBox: '0 0 24 24', fill: color, 'aria-hidden': true } as any;

  // group icon for larger values, person for 1-3
  if (value && (value === 4 || value === 5 || value === 6)) {
    return (
      <svg {...commonProps}>
        <path d="M16 11c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zM8 11c1.66 0 3-1.34 3-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5C15 14.17 10.33 13 8 13zM16 13c-.29 0-.62.02-.97.06 1.16.84 1.97 1.99 1.97 3.44V19h6v-2.5C23 14.17 18.33 13 16 13z" />
      </svg>
    );
  }

  return (
    <svg {...commonProps}>
      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
    </svg>
  );
};
